<template>
    <component
        :is="elementTag"
        v-bind="linkAttributes"
        class="optional-link"
        :class="{ 'is-link': isLink }"
    >
        <slot />
    </component>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            required: false,
            default: null
        },
        fallbackHref: {
            type: String,
            required: false,
            default: null
        },
        disableLink: {
            type: Boolean,
            required: false,
            default: false
        },
        fallbackElement: {
            type: String,
            required: false,
            default: 'span'
        }
    },
    computed: {
        resolvedHref() {
            return this.$validateLink(this.href) 
                ? this.href 
                : this.fallbackHref;
        },
        isLink() {
            return this.$validateLink(this.resolvedHref) && !this.disableLink;
        },
        elementTag() {
            return this.isLink 
                ? 'nuxt-link' 
                : this.fallbackElement;
        },
        linkAttributes() {
            return this.isLink 
                ? { to: this.resolvedHref } 
                : {};
        },
    }
};
</script>